import { createRoot } from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import moment from 'moment';
import './index.scss';
import ApplicationRoutes from "Pages/ApplicationRoutes";
import './Translations';
import { QueryClient, QueryClientProvider } from "react-query";
import i18n from "i18next";
import AuthProvider from "Providers/AuthProvider";
import TranslationProvider from "Providers/TranslationProvider";
import React, { StrictMode } from 'react';
import { toast, ToastContainer } from "react-toastify";
import _ from "lodash";
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            onError: (error: any) => {
                let message;
    
                if (error.status === 404) {
                    return;
                }
                if (error.status === 403) {
                    message = i18n.t('errors.accessDenied');
                } else if (error.status === 413) {
                    message = i18n.t('errors.fileToLarge');
                } else if (error.status === 400) {
                    if (error.data !== "") {
                        message = i18n.t(error.data)
                    }

                    const errors = _.get(error, 'data.errors');

                    const keys = Object.keys(errors ?? {});

                    if (errors && keys.length > 0) {
                        message = errors[keys[0]];
                    }
                } else {
                    message = error.data;
                }

                toast.error(message, {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
    
                console.error(error);
            }
        },
        mutations: {
            onError: (error: any) => {
                let message;
                console.log(error)

                if (error.status === 404) {
                    message = i18n.t('errors.notFound');
                } else if (error.status === 413) {
                    message = i18n.t('errors.fileToLarge');
                } else if (error.status === 400) {
                    if (error.data.message !== "") {
                        message = i18n.t(error.data.message);
                    }

                    if (message === "" && error.data !== "") {
                        message = i18n.t(error.data)
                    }

                    const errors = _.get(error, 'data.errors');
        
                    const keys = Object.keys(errors ?? {});
        
                    if (errors && keys.length > 0) {
                        message = errors[keys[0]];
                    }
                } else {
                    message = error.data;
                }
    
                toast.error(message, {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                
                console.error(error);
            }
        }}
})

moment.locale("da-dk", {
    week: {
        dow: 1,
        doy: 4
    },
    relativeTime: {
        future: "om %s",
        past:   "%s siden",
        s  : 'få sekunder siden',
        ss : '%d sekunder',
        m:  "et minut",
        mm: "%d minutter",
        h:  "en time",
        hh: "%d timer",
        d:  "en dag",
        dd: "%d dage",
        w:  "en uge",
        ww: "%d uger",
        M:  "en måned",
        MM: "%d måneder",
        y:  "et år",
        yy: "%d år"
    },
    months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    weekdays: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
    weekdaysShort: ['Søn', 'Man', 'Tirs', 'Ons', 'Tors', 'Fre', 'Lør'],
    weekdaysMin: ['Søn', 'Man', 'Tirs', 'Ons', 'Tors', 'Fre', 'Lør'],
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
});

const container = document.getElementById('root');
const root = createRoot(container!);

const render = (Component: any) => {
    return root.render(
        <StrictMode>
            <QueryClientProvider client={queryClient}>
                <TranslationProvider>
                    <AuthProvider>
                        <BrowserRouter>
                            <Component />
                            <ToastContainer />
                        </BrowserRouter>
                    </AuthProvider>
                </TranslationProvider>
            </QueryClientProvider>
        </StrictMode>
    );
};

render(ApplicationRoutes);

if (module.hot) {
    module.hot.accept('./Pages/ApplicationRoutes', () => {
        const NextApp = require('Pages/ApplicationRoutes').default;
        render(NextApp);
    });
}
